export default {"src":"/_next/static/media/prev.29545883.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};